import http from "./http";

function getSubscription(data) {
  return http.post(`planList`, data);
}
function addSubscription(data) {
  return http.post(`addPlan`, data);
}
function updateSubscription(data) {
  return http.post(`updatePlan`, data);
}
function deleteSubscription(data) {
  return http.post(`deletePlan`, data);
}

const SubscriptionService = {
  getSubscription,
  addSubscription,
  updateSubscription,
  deleteSubscription,
};

export default SubscriptionService;
